/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { createEntity, getEntity, reset, updateEntity } from './recipe.reducer';

export const RecipeUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const recipeEntity = useAppSelector(state => state.recipe.entity);
  const loading = useAppSelector(state => state.recipe.loading);
  const updating = useAppSelector(state => state.recipe.updating);
  const updateSuccess = useAppSelector(state => state.recipe.updateSuccess);

  const handleClose = () => {
    navigate(`/recipe${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.yeild !== undefined && typeof values.yeild !== 'number') {
      values.yeild = Number(values.yeild);
    }
    if (values.calories !== undefined && typeof values.calories !== 'number') {
      values.calories = Number(values.calories);
    }
    if (values.totalweight !== undefined && typeof values.totalweight !== 'number') {
      values.totalweight = Number(values.totalweight);
    }
    if (values.totaltime !== undefined && typeof values.totaltime !== 'number') {
      values.totaltime = Number(values.totaltime);
    }

    const entity = {
      ...recipeEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...recipeEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.recipe.home.createOrEditLabel" data-cy="RecipeCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.recipe.home.createOrEditLabel">Create or edit a Recipe</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="recipe-id"
                  label={translate('tinyMedicRestApp.recipe.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.recipe.uri')}
                id="recipe-uri"
                name="uri"
                data-cy="uri"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.recipe.tmLabel')}
                id="recipe-tmLabel"
                name="tmLabel"
                data-cy="tmLabel"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.recipe.image')}
                id="recipe-image"
                name="image"
                data-cy="image"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.recipe.source')}
                id="recipe-source"
                name="source"
                data-cy="source"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.recipe.url')}
                id="recipe-url"
                name="url"
                data-cy="url"
                type="text"
                validate={{
                  maxLength: { value: 255, message: translate('entity.validation.maxlength', { max: 255 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.recipe.reference')}
                id="recipe-reference"
                name="reference"
                data-cy="reference"
                type="text"
                validate={{
                  maxLength: { value: 1500, message: translate('entity.validation.maxlength', { max: 1500 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.recipe.yeild')}
                id="recipe-yeild"
                name="yeild"
                data-cy="yeild"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.recipe.calories')}
                id="recipe-calories"
                name="calories"
                data-cy="calories"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.recipe.totalweight')}
                id="recipe-totalweight"
                name="totalweight"
                data-cy="totalweight"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.recipe.totaltime')}
                id="recipe-totaltime"
                name="totaltime"
                data-cy="totaltime"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/recipe" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default RecipeUpdate;
